// Shared date helpers for the owner pages that default to an order week.

// A Date's local calendar day as YYYY-MM-DD. toISOString() cannot be used here:
// it converts to UTC first, so an evening in a US timezone reports tomorrow's
// date and every default window slides a day forward.
export const toISODate = d =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// The bakery's order week runs Saturday through the following Friday.
export const getDefaultDates = (today = new Date()) => {
  const day = today.getDay();
  const daysBack = day === 6 ? 0 : (day + 1) % 7;
  const sat = new Date(today);
  sat.setDate(today.getDate() - daysBack);
  const fri = new Date(sat);
  fri.setDate(sat.getDate() + 6);
  return { start: toISODate(sat), end: toISODate(fri) };
};

// The week that just ended: yesterday, going back seven days.
export const getPastWeekDates = (today = new Date()) => {
  const end = new Date(today);
  end.setDate(today.getDate() - 1);
  const start = new Date(today);
  start.setDate(today.getDate() - 7);
  return { start: toISODate(start), end: toISODate(end) };
};
